import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from 'SelfServeBuilder';
import * as ReactRedux from 'react-redux';
import { bindActionCreators } from 'redux';
import { PreviewIcon } from 'DesignSystem/Icons';
import * as RecipientManagerActions from './RecipientManagerActions';
import PublicLinkToggle from './PublicLinkToggle';
import PublicLinkURLContainer from './PublicLinkURLContainer';


export class PublicLinkBody extends React.PureComponent {
  render() {
    const isToggleButtonIcon = this.props.isPublic;
    return (
      <React.Fragment>
        <div className="content-container">
          <div className="panel-body-header">
            <h3 className="left">Share Link</h3>
            {this.props.isPreviewButtonEnabled && (
              <IconButton
                classnames="preview-button"
                text="View as Recipient"
                icon={<PreviewIcon />}
                containerClass="right full-height"
                onClick={this.props.openPreview}
                imageAlt="Preview"
                imageWidth={16}
              />
            )}
          </div>
          {!this.props.isPublic ? (
            <div className="panel-body-content">
              <p>Paste a link in an email or on your website. </p>
              <p>Anyone with the link can access an individual copy of your document to fill out.</p>
            </div>
          ) : (
            <div className="panel-body-content">
              <PublicLinkURLContainer documentType={this.props.documentType} />
              <p>Anyone with the link can access an individual copy of your document to fill out.</p>
            </div>
          )}
          <PublicLinkToggle
            documentType={this.props.documentType}
            emptyTemplateTooltipText={this.props.emptyTemplateTooltipText}
            isEditingPopup={this.props.isEditingPopup}
            isIcon={isToggleButtonIcon}
            isTemplateEmpty={this.props.isTemplateEmpty}
            isToggledOn={this.props.isPublic}
            togglePublish={this.props.publishedAt ?
              this.props.publicLinkUpdateState : this.props.clickPublish}
            setPopupCreationError={this.props.setPopupCreationError}
          />
        </div>
      </React.Fragment>
    );
  }
}

PublicLinkBody.defaultProps = {
  isEditingPopup: false,
  isPreviewButtonEnabled: true,
  isTemplateEmpty: false,
  publishedAt: null,
  openPreview: null,
};

PublicLinkBody.propTypes = {
  clickPublish: PropTypes.func.isRequired,
  documentType: PropTypes.string.isRequired,
  emptyTemplateTooltipText: PropTypes.string.isRequired,
  isEditingPopup: PropTypes.bool,
  isPreviewButtonEnabled: PropTypes.bool,
  isPublic: PropTypes.bool.isRequired,
  isTemplateEmpty: PropTypes.bool,
  openPreview: PropTypes.func,
  publicLinkUpdateState: PropTypes.func.isRequired,
  publishedAt: PropTypes.string,
  setPopupCreationError: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    ...RecipientManagerActions,
  }, dispatch)
);

const PublicLinkWithRedux = ReactRedux.connect(
  null,
  mapDispatchToProps,
)(PublicLinkBody);

export default PublicLinkWithRedux;



// WEBPACK FOOTER //
// ./src-react/SelfServePostBuilderSidePanel/RecipientManager/PublicLinkBody.jsx